import React, { ReactElement } from 'react';
import { IProps } from './types';
import { Typography } from '@material-ui/core';
import UtilsService from 'shared-services/utils-service';
import {renderIf} from 'shared-services/react-utils-service';
import { servicePaymentType } from 'shared-types/SharedTypes';
import ExternalLinkContainer from 'internal-components/ExternalLink/container';
import { externalLinkType } from 'shared-components/external-link/types';
import { noCase } from 'change-case';
import { IntlService } from 'shared-services/intl-service/index';

const NS = 'PaymentMessage';

export default function PaymentMessage({
  paymentType, price, covers, currency, hasMenuOptions, bgColor, isPricePerPerson, dividePriceByCovers
}: IProps) {

  const Price = ({calcPrice}: {calcPrice: number}): ReactElement => {
    return (
      <span className="secondary-text">
        {IntlService.currencyValue(calcPrice, currency)}
      </span>
    )
  }

  const PRE_AUTH_TEXT = () => (
    <Typography variant="body1" data-testid="pre-auth-text">
      A credit card Booking Guarantee of&nbsp;
      <Price calcPrice={hasMenuOptions || dividePriceByCovers ? price : price * covers}/> is required to finalise
      your {UtilsService.getOrderType()}.
      Funds will be verified, but not charged to your card at this time.&nbsp;
      <ExternalLinkContainer label="View Booking Guarantee Policy." type={externalLinkType.preAuth} bgColor={bgColor}/>
    </Typography>
  );

  return (
    <div>
      {renderIf(!paymentType || paymentType === servicePaymentType.noPayment, () => (<></>), () => (
        renderIf(hasMenuOptions, () => (
          renderIf(paymentType === servicePaymentType.preAuth,
            // show preauth text
            PRE_AUTH_TEXT, () => (
            // else not preauth
            <Typography variant="body1">
              A { noCase(paymentType) } for each booking option is required.
            </Typography>
          ))
        ), () => (
          renderIf(paymentType === servicePaymentType.functionPayment, () => (
            <Typography variant="body1" data-testid="function-text">
              A payment of <Price calcPrice={price} /> is required to finalise your {UtilsService.getOrderType()}.
            </Typography>
          ), () => (
            renderIf(paymentType === servicePaymentType.preAuth, PRE_AUTH_TEXT, () => (
              (() => {
                const calcPrice: number = isPricePerPerson && dividePriceByCovers ? (price/covers) : price;
                return (
                  <Typography variant="body1">
                    A { noCase(paymentType) } of <Price calcPrice={calcPrice} /> {isPricePerPerson ? 'per person ' : ''}is required to finalise your {UtilsService.getOrderType()}.
                  </Typography>
                );
              })()
            ))
          ))
        ))
      ))}
    </div>
  )
}
